import { jsx as _jsx } from "react/jsx-runtime";
import { Popover, Whisper } from "rsuite";
function HoverOverlay(props) {
    const { contents, children, delay = 300, onHover, followCursor } = props;
    const placement = props.placement === undefined ? "auto" : props.placement;
    const renderTooltip = () => _jsx(Popover, { children: contents });
    return (_jsx(Whisper
    // @ts-ignore
    , { 
        // @ts-ignore
        placement: placement, controlId: "control-id-hover-enterable", trigger: "hover", speaker: renderTooltip(), enterable: followCursor ? false : true, followCursor: followCursor ? true : false, onEntering: onHover !== undefined ? onHover : () => { }, delayOpen: delay, children: children }));
}
export default HoverOverlay;
